<div
  class="card-order-access-point"
  [class.card-order-access-point--disabled]="disabled"
>
  <div class="card-order-access-point__map-wrap" #mapWrap>
    <div class="card-order-access-point__map" #mapContainer></div>
  </div>

  <div class="card-order-access-point__list" #listContainer role="listbox">
    <button
      type="button"
      class="card-order-access-point__list-item"
      role="option"
      *ngFor="let point of points; trackBy: trackByPointId"
      [attr.data-access-point-id]="point.id"
      [attr.aria-selected]="isSelected(point)"
      [class.card-order-access-point__list-item--selected]="isSelected(point)"
      [disabled]="disabled"
      (click)="selectPoint(point)"
    >
      <span
        class="card-order-access-point__list-pin"
        aria-hidden="true"
        [innerHTML]="getPinHtml(isSelected(point), true)"
      ></span>
      <span class="card-order-access-point__list-content">
        <span class="card-order-access-point__list-name">
          {{ formatUpsAccessPointName(point.name) }}
        </span>
        <span class="card-order-access-point__list-address">
          {{ formatUpsAccessPointAddress(point) }}
        </span>
        <span
          class="card-order-access-point__list-distance"
          *ngIf="formatUpsAccessPointDistanceKm(point.distanceKm) as distance"
        >
          {{ "cardOrders.accessPointDistance" | translate : { distance } }}
        </span>
        <span
          class="card-order-access-point__list-hours"
          *ngIf="formatUpsAccessPointOpeningHours(point.openingHours) as openingHours"
        >
          <span class="card-order-access-point__list-hours-label">
            {{ "cardOrders.accessPointOpeningHoursLabel" | translate }}
          </span>
          {{ openingHours }}
        </span>
      </span>
    </button>
  </div>
</div>
